<template>
    <div>
        <CommonPopupFrame :isOpen="isOpen" :changeBottom="0" :closeCompleteAction="close" closeType="select-age" :change-height="450" :change-height-unit="'px'">
            <div style="display:flex; flex: 1; flex-direction: column;">
                <div style="border-bottom: 1px solid #ebebeb; padding: 0 20px; padding-bottom: 14px;">
                    <div style="text-align:center;">
                        <div style="width: 36px; height: 5px; background-color: rgb(217, 217, 217); margin: 5px auto 0px; border-radius: 5px;"></div>
                    </div>
                    <div style="display:flex; margin-top: 16px; position: relative; align-items: center;">
                        <div @click="close" style="position: relative; font-weight: 700;">
                            닫기
                        </div>
                        <div style="position: absolute; left: 50%; transform: translateX(-50%);">
                            <div style="font-weight:700; margin-bottom: 5px;" @click="submit">댓글 수정하기</div>
                        </div>
                    </div>
                </div>
                <div class="edit-inner" style="flex:1; padding: 0 12px; padding-top:20px;">
                    <div v-if="!isChildReply" style="position: relative;">
                        <div style="display: flex; gap: 8px; background-color: #f5f5f5; border-radius: 12px; padding: 12px; position: relative; padding-bottom: 0;">
                            <!-- <div @click="deleteContents" style="position: absolute; top: 50%; transform: translateY(-50%); right: 12px;">
                                <img style="width: 20px;" :src="require('@/assets/img/reply_x_btn.png')" alt="">
                            </div> -->
                            <div>
                                <ProfileImage :imagePath="myInfo.image_path" style="width: 40px;"></ProfileImage>
                            </div>
                            <div>
                                <div v-if="myInfo.writer_is_coach == 0" style="font-weight: 700; font-size: 12px; display: flex; align-items: center; gap: 4px;">{{myInfo.nic_name}} <span style="color: var(--color-main); font-weight: 900;">{{ myInfo.position }}</span></div>
                                <div v-else style="font-weight: 700; font-size: 12px; display: flex; align-items: center; gap: 4px;">{{myInfo.nic_name}}
                                    <img v-if="myInfo.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                    <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                </div>
                                <textarea ref="elTextArea" class="contents_textarea" :placeholder="'댓글을 수정할 수 있습니다.'"
                                    style="line-height: 20px; border-radius: 10px; background-color: #f5f5f5; border: none; outline: none; font-size:15px;color:black;resize:none; padding-right: 35px; max-height: 180px; width:100%; white-space: pre-wrap;"
                                    v-model="contents" oninput='this.style.height = ""; this.style.height = (this.scrollHeight) + "px"'>
                                </textarea>
                            </div>
                        </div>
                        <!-- <div style='margin-top: 4px; font-size: 14px; color: #bbbbbb;'>{{`${contents.length}/500`}}</div> -->
                    </div>
                    <div v-else style="background-color: #f5f5f5; padding: 12px; border-radius: 12px;">
                        <div style="display: flex; gap: 8px;">
                            <div style="width: 40px; height: 40px;">
                                <ProfileImage style="width: 40px; height: 40px;" :image-path="opponentInfo.image_path"></ProfileImage>
                            </div>
                            <div>
                                <div style="font-weight: 700; font-size: 12px; line-height: 24px; display:flex; align-items: center;">
                                    {{ opponentInfo.nic_name }}
                                    <template v-if="opponentInfo.writer_is_coach == '1'">
                                        <img v-if="opponentInfo.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="margin-left:5px;width: 13px; vertical-align: bottom;" :src="require('@/assets/img/blue_star.png')" alt="">
                                        <img v-else style="margin-left:5px;width: 13px; vertical-align: bottom;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                    </template>
                                    <span v-else style="font-weight: 900; font-size: 11px; margin-left: 4px; color: var(--color-main);">{{ opponentInfo.position }}</span>
                                </div>
                                <div style="font-weight: 500; font-size: 15px; line-height: 24px;">{{ opponentInfo.contents }}</div>
                            </div>
                        </div>
                        <div style="border-left: 1px solid #EBEBEB; padding-left: 10px; margin-top: 16px;">
                            <div style="margin-top: 16px;">
                                <div style="display: flex; gap: 8px;">
                                    <div style="width: 40px; height: 40px;">
                                        <ProfileImage style="width: 40px; height: 40px;" :image-path="myInfo.image_path"></ProfileImage>
                                    </div>
                                    <div>
                                        <div style="font-weight: 700; font-size: 12px; line-height: 24px; display:flex; align-items: center;">
                                            {{ myInfo.nic_name }}
                                            <template v-if="myInfo.writer_is_coach == '1'">
                                                <img v-if="myInfo.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="margin-left:5px;width: 13px; vertical-align: bottom;" :src="require('@/assets/img/blue_star.png')" alt="">
                                                <img v-else style="margin-left:5px;width: 13px; vertical-align: bottom;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                            </template>
                                            <span v-else style="font-weight: 900; font-size: 11px; margin-left: 4px; color: var(--color-main);">{{ myInfo.position }}</span>
                                        </div>
                                        <textarea ref="elTextArea" class="contents_textarea" :placeholder="'댓글을 수정할 수 있습니다.'"
                                            style="line-height: 20px; border-radius: 10px; background-color: #f5f5f5; border: none; outline: none; font-size:15px;color:black;resize:none; padding-right: 35px; max-height: 180px; width:100%; white-space: pre-wrap;"
                                            v-model="contents" oninput='this.style.height = ""; this.style.height = (this.scrollHeight) + "px"'>
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 93px; padding: 0 12px;">
                <div @click="submit" :class="contents.length === 0 ? 'un_active' : 'active'" style="margin-top: 5px; border-radius: 12px; height: 48px; line-height: 48px; text-align: center; font-size: 14px; font-weight: 500;">수정하기</div>
            </div>

        </CommonPopupFrame>
    </div>
</template>

<script>
    import CommonPopupFrame from "../modal/my/CommonPopupFrame";
    import {FORM_MODE, TEAM_TYPE} from "../../Constants";
    import ResponseCode from "../../ResponseCode";
    import ProfileImage from "@/components/common/ProfileImage"
    export default {
        name: "SoccerHowReplyUpdatePopup",
        components: {CommonPopupFrame, ProfileImage},
        props : {
            signalOpen : {
                type : Boolean,
                default : false,
            },
            soccerhow_idx : {
                type : [String, Number],
                default : -1
            },
            completeAction : {
                type : Function,
                default : () => {}
            },
            myInfo: {
                type: Object,
                default: () => {}
            },
            opponentInfo: {
                type: Object,
                default: () => {}
            },
            isChildReply: {
                type: Boolean,
                default: false
            }
        },
        watch : {
            signalOpen(){
                this.isOpen = true;
                this.getSoccerHow();
            }
        },
        data(){
            return {
                isOpen : false,
                title : '',
                contents : '',
                isCheckedFastAnswer : false,
                topicData : '',
                enterdPoint : '',
                imgSrcArr : [],
                prevSoccerHow : {},
                type : '',
                TEAM_TYPE: TEAM_TYPE
            }
        },
        methods : {
            close(){
                this.isOpen = false;
                this.title = '';
                this.contents = '';
                this.isCheckedFastAnswer = false;
                this.topicData = '';
                this.enterdPoint = '';
                this.imgSrcArr = [];
                this.prevSoccerHow = {};
                this.type = '';
            },
            deleteContents() {
                this.contents = ''
            },
            async getSoccerHow(){
                const parameters = {};
                parameters.idx = this.soccerhow_idx;
                parameters.isParentIdxesEmpty = true;
                const res = await this.$Axios.get('/api/soccerhow/list', {params : parameters});
                const data = res.data.soccerHows[0];

                this.contents = data.contents;
                this.title = data.title;
                this.isCheckedFastAnswer = (data.fast_answer === '1');
                this.topicData = data.topic;
                this.enterdPoint = parseInt(data.point);
                this.imgSrcArr = [];
                this.prevSoccerHow = data;
                this.type = data.type;
            },
            async submit(){
                if(this.contents === '' || this.contents.length === 0){
                    this.$GlobalStore.showAlert('내용을 입력해주세요.');
                    return;
                }

                const formData = new FormData();
                // formData.append('topic', this.topicData);
                // console.log('topicData : ',this.topicData);
                // formData.append('entredPoint', this.enterdPoint);
                // formData.append('isCheckedFastAnswer', (this.isCheckedFastAnswer ? '1' : '0'));
                // formData.append('title', this.title);
                formData.append('contents', this.contents);
                formData.append('type', this.type);
                formData.append('mode', FORM_MODE.UPDATE);
                formData.append('isYoutubeExist', '0');
                formData.append('soccerhowIdx', this.prevSoccerHow.idx);
                this.$GlobalStore.showProgress();
                const res = await this.$Axios.post('/api/soccerhow/save',  formData, { headers: { 'Content-Type': 'multipart/form-data' }});
                this.$GlobalStore.hideProgress();

                if(res.data.code === ResponseCode.SUCCESS){
                    this.completeAction();
                    this.close();
                }else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }

            }
        }

    }
</script>

<style scoped>
    input::placeholder, textarea::placeholder{color:#afafaf;;}
    .contents_textarea:focus{outline:1px solid #ff8c21 ;}
    .un_active {
        background-color: #f5f5f5;
        color: #d9d9d9;
    }
    .active {
        background-color: #210f03;
        color: #fff;
    }
</style>